<template>
<div class="absolute" ref="divSize">
	<custom-popover class="expression-editor-popover" @close="$emit('close')" :backdrop="true" :closeButtonOff="true" :class="moveLeft ? 'move-left' : ''" >
		<expression-editor
			:expression="expression"
			@add="$emit('add')"
			@expression-updated="expression => $emit('expression-updated', expression)"
			@remove="$emit('remove')"
			@close="$emit('close')" />
	</custom-popover>
</div>
</template>

<script> 
	import EventBus from '@/assets/js/eventBus.js'
	import CustomPopover from '@/components/CustomPopover'
	import ExpressionEditor from '@/components/ExpressionEditor'
	export default {
		name: 'expressionEditorPopover',
		data() {
			return {
				// moveLeft: false
			}
		},
		props: {
			expression: {
				type: String,
				required: true
			},
			expressionObject: Object,
			moveLeft: Boolean
		},
		methods: {
			// enableMoveLeft(){
			// 	this.moveLeft = true
			// 	console.log("yo=")
			// },
			// disableMoveLeft(){
			// 	this.moveLeft = false
			// 	console.log("yo?")
			// }
		},
		// mounted() {
		// 	EventBus.$on('close_panel',this.disableMoveLeft)
		// 	EventBus.$on('open_panel', this.enableMoveLeft)
		// },
	
		components: {
			CustomPopover,
			ExpressionEditor
		}
	}
</script>

<style lang="less">

//Temporary solution.... (.absolute)
.absolute{
		position: absolute;
		top: 0;
}
	.custom-popover {
		&.expression-editor-popover {
			// position: relative;
			z-index: 999;
			// top: 0;

		}
		&:before {
			display: none;
			left: 15px
		}

		// .trash {
		// 	position: absolute;
		// 	right: 13px; 
		// 	top: 13px; 
		// 	z-index: 9999;
		// 	img {
		// 		width: 22px;
				
		// 	}
		// }


  .close-button {
    position: absolute;
    top: -13px;
    right: 6px;
    z-index: 101;

    &:hover {
      cursor: pointer;
    }

    img {
      width: 24px;
    }
  }
	}
</style>

